<template>
  <div class="fb fb-wrap font-34">
    <div
      v-for="(node, idx) in renderStudentsList"
      class="fb fb-cross-center fb-main-center w-p-25 h-112"
      :key="node.studentDingId"
      @click="handlerToChangeSelectedStatus(node, idx)"
    >
      <div class="fb fb-col fb-cross-center fb-main-center relative">
        <span class="absolute icon-position" v-show="isMultiple">
          <i v-show="!node.selected" class="iconfont c-DBDBDB font-48">
            &#xe66e;
          </i>
          <i v-show="node.selected" class="iconfont c-006AFE font-48">
            &#xe66e;
          </i>
        </span>
        <div v-if="node.studentDingId" class="font-24">
          <div
            class="h-60 w-60 c-FFFFFF bd-p-50 fb fb-cross-center fb-main-center"
          >
            <img
              v-if="+node.gender === 1"
              :key="node.gender"
              src="@/assets/images/avator1-1.png"
            />
            <img
              :key="node.gender"
              v-else-if="+node.gender === 2"
              src="@/assets/images/avator2-1.png"
            />
            <img v-else src="@/assets/images/avator0-1.png" />
          </div>
        </div>
        <span class="font-34 pr-5 text-ellipsis max-w-220">
          {{ filterName(node.studentName, 5) }}
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import { filterName } from '@/utils/comUtils'
import {} from '@/utils/constUtils'

export default {
  name: 'evaluationChooseBatchStudent',

  props: {
    studentList: {
      type: Array,
      default: () => []
    },
    isMultiple: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      filterName,
      renderStudentsList: []
    }
  },
  computed: {
    computedSelectedList() {
      return this.renderStudentsList.filter(item => item.selected)
    }
  },
  watch: {
    studentList: {
      // eslint-disable-next-line space-before-function-paren
      handler: function (newList) {
        this.processingList(newList)
      },
      deep: true,
      immediate: true
    },
    computedSelectedList: {
      // eslint-disable-next-line space-before-function-paren
      handler: function (newList) {
        this.emitSelectedList(newList)
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    // 对原始数据进行处理
    processingList(newList) {
      this.renderStudentsList = []
      if (newList && newList.length) {
        this.renderStudentsList = newList.map(item => {
          return {
            selected: false,
            ...item
          }
        })
      }
    },
    // 切换节点状态
    handlerToChangeSelectedStatus(node, index) {
      if (this.isMultiple) {
        node.selected = !node.selected
        this.renderStudentsList.splice(index, 1, node)
      } else {
        this.renderStudentsList = this.studentList.map(item => {
          return {
            selected: item.memberId === node.memberId,
            ...item
          }
        })
      }
    },
    emitSelectedList(selectList) {
      this.$emit('change', selectList)
    }
  }
}
</script>

<style lang="scss" scoped>
.c-DBDBDB {
  color: #dbdbdb;
}
.icon-position {
  right: -8px;
  top: 33px;
  z-index: 9;
}
</style>
